import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import Footer from 'components/footer';
import { SubmitModal, InvalidModal, Header, InvalidSubModal } from './components';
import { getUser } from 'store/user/actions';
import Spinner from 'components/spinner';
import { includes, isEmpty } from 'lodash';
import { isAdminUser } from 'utils';

const { Content } = Layout;

const AppLayout = () => {
  const [isVisible, setVisible] = useState(false);
  const [invalidModalVisible, setInvalidModalVisible] = useState(false);
  const [invalidSubModalVisible, setInvalidSubModalVisible] = useState(false);
  const [outcome, setOutcome] = useState('');
  const submitDisabled = false;
  const userStatus = useSelector(state => state.user.status)
  const state = useSelector(state => state);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const groups = useSelector(state => state.user.groups)

  const fullscreenPages = ["/go-beyond", "/go-beyond/"]

  useEffect(() => {

    dispatch(getUser());

  },[])

  useEffect(() => {

    if(userStatus===200 && isAdminUser(groups)) navigate("/admin")

  },[userStatus, groups, navigate])

  return(
    
    fullscreenPages.includes(window.location.pathname) ?
    <div>
      <Outlet />
    </div>
    :
    <div >
    <Header/>
    <div id="content-container">
        <Spinner/>
        <div id="main-content" className='main-container'>
          <Outlet />
        </div>
    </div>
      <Footer/>
    </div>
  )
};

export default AppLayout;
